import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { useTranslator } from '@jutro/locale';
import { ViewModelForm, useDataRefresh } from '@xengage/gw-portals-viewmodel-react';

import metadata from './MLViewAllPoliciesAdditionalFilter.metadata.json5';

const MLViewAllPoliciesAdditionalFilter = (props) => {
    const {
        filterData,
        updateFilterData,
        stateList
    } = props;
    const { refreshData } = useDataRefresh();
    const translator = useTranslator();
    const [states, updateStates] = useState([]);

    useEffect(() => {
        const stateAvailableValues = stateList.map((state) => {
            return {
                code: state.code,
                name: translator({
                    id: state.name,
                    defaultMessage: state.name
                })
            };
        });
        updateStates(stateAvailableValues);
    }, []);

    const onValueChange = (value, path) => {
        _.set(filterData, path, value);
        updateFilterData(filterData);
        refreshData();
    }

    const overrideProps = {
        stateInput: {
            availableValues: states,
            onValueChange
        }
    };

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            overrideProps={overrideProps}
            model={filterData}
        />
    );
};

MLViewAllPoliciesAdditionalFilter.propTypes = {
    filterData: PropTypes.shape({}).isRequired,
    updateFilterData: PropTypes.func.isRequired,
    stateList: PropTypes.array.isRequired
};

export default MLViewAllPoliciesAdditionalFilter;
